var map = {
	"./comments/AddComment": 9189,
	"./comments/AddComment.jsx": 9189,
	"./comments/Comments": 6883,
	"./comments/Comments.jsx": 6883,
	"./comments/CommentsSection": 126,
	"./comments/CommentsSection.jsx": 126,
	"./controls/filters/event_filter": 9748,
	"./controls/filters/event_filter.jsx": 9748,
	"./controls/filters/filters_actions": 2356,
	"./controls/filters/filters_actions.js": 2356,
	"./controls/filters/filters_constants": 7162,
	"./controls/filters/filters_constants.js": 7162,
	"./controls/filters/filters_reducers": 8986,
	"./controls/filters/filters_reducers.js": 8986,
	"./controls/filters/month_filter": 7530,
	"./controls/filters/month_filter.jsx": 7530,
	"./controls/filters/season_filter": 6877,
	"./controls/filters/season_filter.jsx": 6877,
	"./controls/filters/tournament_filter": 9963,
	"./controls/filters/tournament_filter.jsx": 9963,
	"./events/event": 1084,
	"./events/event.jsx": 1084,
	"./events/events": 9521,
	"./events/events.jsx": 9521,
	"./events/game": 1724,
	"./events/game.jsx": 1724,
	"./events/header": 4445,
	"./events/header.jsx": 4445,
	"./events/training": 8820,
	"./events/training.jsx": 8820,
	"./glossary_terms": 5475,
	"./glossary_terms/": 5475,
	"./glossary_terms/index": 5475,
	"./glossary_terms/index.jsx": 5475,
	"./helpers/NotificationContext": 5684,
	"./helpers/NotificationContext.jsx": 5684,
	"./helpers/successAlert": 8521,
	"./helpers/successAlert.jsx": 8521,
	"./latest_games": 9058,
	"./latest_games/": 9058,
	"./latest_games/game_result": 4,
	"./latest_games/game_result.jsx": 4,
	"./latest_games/index": 9058,
	"./latest_games/index.jsx": 9058,
	"./nav_bar/brand_logo/brand_logo": 9713,
	"./nav_bar/brand_logo/brand_logo.jsx": 9713,
	"./settings/AboutUsAchievementsManager": 9450,
	"./settings/AboutUsAchievementsManager.jsx": 9450,
	"./settings/AboutUsSettings": 4308,
	"./settings/AboutUsSettings.jsx": 4308,
	"./settings/AboutUsTabsManager": 5250,
	"./settings/AboutUsTabsManager.jsx": 5250,
	"./settings/AnalyticsSettings": 9455,
	"./settings/AnalyticsSettings.jsx": 9455,
	"./settings/BreadcrumbsImageManager": 418,
	"./settings/BreadcrumbsImageManager.jsx": 418,
	"./settings/CardScoringPage": 6528,
	"./settings/CardScoringPage.jsx": 6528,
	"./settings/CardScoringSettings": 5714,
	"./settings/CardScoringSettings.jsx": 5714,
	"./settings/ColorSettings": 8158,
	"./settings/ColorSettings.jsx": 8158,
	"./settings/ContactSettings": 6999,
	"./settings/ContactSettings.jsx": 6999,
	"./settings/HomeSliderManager": 2043,
	"./settings/HomeSliderManager.jsx": 2043,
	"./settings/ImageSettings": 5360,
	"./settings/ImageSettings.jsx": 5360,
	"./settings/LinesManager": 2868,
	"./settings/LinesManager.jsx": 2868,
	"./settings/SeoSettings": 5372,
	"./settings/SeoSettings.jsx": 5372,
	"./settings/Settings": 4417,
	"./settings/Settings.jsx": 4417,
	"./settings/SocialLinksSettings": 7391,
	"./settings/SocialLinksSettings.jsx": 7391,
	"./settings/SymbolsManager": 6974,
	"./settings/SymbolsManager.jsx": 6974,
	"./settings/TeamNameSettings": 6067,
	"./settings/TeamNameSettings.jsx": 6067,
	"./standings": 5478,
	"./standings/": 5478,
	"./standings/index": 5478,
	"./standings/index.jsx": 5478,
	"./standings/standings_actions": 8123,
	"./standings/standings_actions.js": 8123,
	"./standings/standings_reducer": 4900,
	"./standings/standings_reducer.js": 4900,
	"./standings/standings_table": 2972,
	"./standings/standings_table.jsx": 2972,
	"./user/user": 1613,
	"./user/user.jsx": 1613,
	"./user/user_actions": 1563,
	"./user/user_actions.js": 1563,
	"./user/user_constants": 6757,
	"./user/user_constants.js": 6757,
	"./user/user_reducers": 8443,
	"./user/user_reducers.js": 8443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6900;